<div class="brand">
  <div class="container">
    <div class="context-wrapper footer">
      <nav class="col-md-9 col-lg-10 ftr-urlt-lnk">
        <h2 class="wb-inv">{{'footer.aboutThisSite' | translate}}</h2>
        <ul>
          <li>
            <a href="{{'footer.socialMedia_link' | translate }}" target="_blank">{{'footer.socialMedia' | translate }}</a>
          </li>
          <li>
            <a href="{{'footer.mobileApplication_link' | translate }}" target="_blank">{{'footer.mobileApplication' | translate}}</a>
          </li>
          <li>
            <a href="{{'footer.aboutCanada_link' | translate }}" target="_blank">{{'footer.aboutCanada' | translate }}</a>
          </li>
          <li>
            <a href="{{'footer.termsConditions_link' | translate}}" target="_blank">{{'footer.termsConditions' | translate }}</a
            >
          </li>
          <li>
            <a href="{{'footer.privacy_link'|translate}}" target="_blank">{{'footer.privacy'|translate}}</a>
          </li>
        </ul>
      </nav>
      <div class="col-xs-6 col-md-3 col-lg-2 text-right">
        <img
          src="{{'footer.canadaLogo' | translate}}"
          alt="{{'footer.symbolGovernmentCanada' | translate}}"
        />
      </div>
    </div>
  </div>
</div>
